import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useJourneyContext } from '../../../../context/journey/hooks/use-journey-context';
import { Icon } from '../../../../subcomponents/icon/icon';
const b = bemClassBuilder('v-journey-action-button');
export const JourneyActionButtonBase = observer(props => {
    const { journey } = useJourneyContext();
    if (!journey)
        return null;
    const handleOnClick = () => props.onClick(journey);
    return (_jsxs("button", Object.assign({ className: b.block(undefined, props.className), onClick: handleOnClick }, { children: [props.iconName && _jsx(Icon, { name: props.iconName, className: b.element('icon') }), _jsx("div", Object.assign({ className: b.element('label') }, { children: props.label }))] })));
});
JourneyActionButtonBase.displayName = 'JourneyActionButtonBase';
